/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const WizardBillsDocModalOrderResultStyled = styled.div.attrs({
    className: 'bill-doc-modal-order',
})`
    .success-container {
        margin-bottom: 16px;
    }

    .error-container {
        margin: 0 0 16px 0;
        padding: 16px 0;
        border-top: 1px solid ${colors.borderColorSeparate};
        border-bottom: 1px solid ${colors.borderColorSeparate};
        text-align: left;

        > *:not(:last-child) {
            margin-bottom: 8px;
        }
    }
`;
